import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./pendingBooksJson.scss";

function PendingBooksJson() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = "Wishallbook >> Pending Books JSON";
    fetchBooks();
  }, []);

  const fetchBooks = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, "pendingBooks"));
      const booksData = [];
      
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const numericFields = { id: doc.id };
        
        // Extract all numeric fields
        Object.keys(data).forEach(key => {
          if (typeof data[key] === 'number') {
            numericFields[key] = data[key];
          }
        });
        
        booksData.push(numericFields);
      });
      
      setBooks(booksData);
      setError(null);
    } catch (err) {
      console.error("Error fetching pending books:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pendingBooksJson">
      <Sidebar />
      <div className="pendingBooksJsonContainer">
        <Navbar />
        <div className="jsonContent">
          <div className="jsonHeader">
            <h2>Pending Books JSON Data</h2>
            <button onClick={fetchBooks} className="refreshBtn">
              Refresh
            </button>
          </div>
          
          {loading && <div className="loading">Loading pending books...</div>}
          
          {error && <div className="error">Error: {error}</div>}
          
          {!loading && !error && (
            <pre className="jsonDisplay">
              {JSON.stringify(books, null, 2)}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
}

export default PendingBooksJson;
